import { render, staticRenderFns } from "./TagMultiple.vue?vue&type=template&id=2b424493"
import script from "./TagMultiple.vue?vue&type=script&lang=js"
export * from "./TagMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports